import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import {
  SectionContainer,
  SectionTitle,
  SectionDetails,
} from '../../shared/sectionable/styles';
import Bio from './about-components/bio';
import Expertise from './about-components/expertise';
import Career from './about-components/career';
import InvestmentPhilosophy from './about-components/investment-philosophy';
import { scrollIfHashMatch } from '../../shared/navigation/utils';

const AboutContainer = styled(SectionContainer)`
  margin-top: ${props => (props.theme.isMobile ? 0 : 56)}px;
`;

const sectionName = 'about';
export default function About({ profile }) {
  const {
    firstName,
    name,
    blurb,
    areasOfExpertise,
    investmentPhilosophy,
  } = profile;

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  const title = `About ${firstName || name}`;

  return (
    <AboutContainer name={sectionName}>
      <SectionTitle>{title}</SectionTitle>
      <SectionDetails>
        <Bio blurb={blurb} />
        <Expertise areasOfExpertise={areasOfExpertise} />
        <Career {...profile} />
        <InvestmentPhilosophy investmentPhilosophy={investmentPhilosophy} />
      </SectionDetails>
    </AboutContainer>
  );
}

About.propTypes = {
  profile: PropTypes.shape({
    name: PropTypes.string,
    firstName: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    joinedCurrentRoleAt: PropTypes.string,
    recentCareer: PropTypes.shape({
      organisation: PropTypes.string,
      position: PropTypes.string,
      joinedAt: PropTypes.string,
      leftAt: PropTypes.string,
    }),
    joinedIndustryAt: PropTypes.string,
    accred: PropTypes.string,
    countryName: PropTypes.string,
    cityName: PropTypes.string,
    blurb: PropTypes.string,
    areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
    })),
    investmentPhilosophy: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};
